import { ChangeDetectorRef, Directive, ElementRef, HostBinding, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject, of, switchMap, takeUntil } from 'rxjs';
import { FormControlService } from '../form-control.service';

@Directive({
  selector: '[ssFormValidationMessage]'
})
export class FormValidationMessageDirective implements OnInit {

  private readonly _destroy = new Subject<void>();

  constructor(
    private readonly _formControlService: FormControlService,
    private readonly _changeDetectorRef: ChangeDetectorRef,
    private readonly _elementRef: ElementRef<HTMLElement>,
    private readonly _translateService: TranslateService
  ) { }

  ngOnInit() {

    this._formControlService
      .validationMessageSubject
      .pipe(
        takeUntil(this._destroy),
        switchMap((msg) => msg ? this._translateService.get(msg) : of(msg))
      )
      .subscribe((validationMessage) => {


        this._elementRef.nativeElement.innerHTML = validationMessage;

        this._changeDetectorRef.detectChanges();
      })

  }

  @HostBinding('innerHTML') validationMessage?: string;

  @HostBinding('style.font-size') fontSize = '0.8em'


  ngOnDestroy() {
    this._destroy.next()
    this._destroy.complete()
  }
}
